// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2zN9M","assignButton":"CreateEditEquipmentSchedule_assignButton__xUkoJ"};